
export const tableStyles = {
    border: '1px solid #BDBDBD',
    width: '100%',
    borderCollapse: 'collapse'
}

export const trStyles = {
    borderBottom: '1px solid #BDBDBD'
}

export const rowStyles = {
    border: '0',
    background: '#FFFFFF',
    textAlign: 'center',
    borderRight: '1px solid #BDBDBD'
}

export const headerStyles = {
    border: '0',
    background: '#F2F2F2',
    textAlign: 'center',
    borderRight: '1px solid #BDBDBD',
    fontSize: '12px',
    height: '30px'
}
